import React from 'react'

import { BasicModal } from '@/components/layout/modals/BasicModal'

import { NotificationSettings } from './NotificationSettings'

// v1: a single modal holding the user's notification settings — filter
// (which agents/tags they care about) and the per-event/per-channel
// matrix all save together. The old SegmentedControl two-tab pattern
// (Subscriptions + Delivery) is gone.
export const NotificationPreferences = ({ show, onClose, onSaved = onClose }) => (
  <BasicModal title="Notification Settings" show={show} onClose={onClose} size="small">
    <NotificationSettings onSaved={onSaved} />
  </BasicModal>
)
